import React from "react";
import { Card as AntCard } from "antd";
import type { CardProps as AntCardProps } from "antd";

/** Оболочка над antd Card, чтобы компонент был лёгким и унифицированным. */
export function Card({ className, style, ...rest }: AntCardProps) {
  return (
    <AntCard
      // убираем штатную рамку и делаем плавные углы,
      bordered={false}
      className={className}
      style={{
        borderRadius: 16,
        background: "rgba(255,255,255,0.05)", // лёгкий «стеклянный» фон
        ...style,
      }}
      {...rest}
    />
  );
}

/** Внутренний контейнер с паддингом — аналог shadcn/ui `<CardContent>` */
export function CardContent(
  props: React.HTMLAttributes<HTMLDivElement> & { padding?: number }
) {
  const { children, padding = 16, style, ...rest } = props;
  return (
    <div
      {...rest}
      style={{
        padding,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
